/**
 * tdVimeoPlayers — Vimeo playlist player management
 *
 * Migrated from Froogaloop (deprecated 2016) to @vimeo/player.
 * Manages one or more Vimeo playlist widgets on a page, each containing
 * a player iframe and a clickable playlist of videos.
 */
import jQuery from 'jquery';
import Player from '@vimeo/player';
import { tdDetect } from '../core/detect';

// @todo this ready hook function must be moved from here
jQuery().ready(function () {
    tdVimeoPlayers.init();
});

export const tdVimeoPlayers: Record<string, any> = {

    // the part name of the player id (they will be ex 'player_vimeo_0', 'player_vimeo_1', 'player_vimeo_2', ...)
    tdPlayerContainer: 'player_vimeo',

    // the internal list
    players: [],

    // Set to true at the first autoplayed player created
    // It's used to avoid the autoplay setting of the next players (multiple players can't have autoplay = 1 )
    existingAutoplay: false,


    // init the vimeo list players
    init: function () {
        var jqTDWrapperPlaylistPlayerVimeo = jQuery('.td_wrapper_playlist_player_vimeo');

        for (var i = 0; i < jqTDWrapperPlaylistPlayerVimeo.length; i++) {
            var vimeoPlayer = tdVimeoPlayers.addPlayer(jQuery(jqTDWrapperPlaylistPlayerVimeo[i]));
            if (0 !== vimeoPlayer.autoplay) {
                tdVimeoPlayers.existingAutoplay = true;
            }
        }


        //click on a vimeo
        jQuery('.td_click_video_vimeo').click(function () {

            var videoId = jQuery(this).data('video-id'),
                playerId = jQuery(this).data('player-id');

            if (undefined !== playerId && '' !== playerId && undefined !== videoId && '' !== videoId) {
                tdVimeoPlayers.operatePlayer(playerId, 'play', videoId);
            }
        });


        //click on vimeo play control
        jQuery('.td_vimeo_control').click(function () {

            var playerId = jQuery(this).data('player-id');

            if (undefined !== playerId && '' !== playerId) {
                if (jQuery(this).hasClass('td-sp-video-play')) {
                    tdVimeoPlayers.operatePlayer(playerId, 'play');
                } else {
                    tdVimeoPlayers.operatePlayer(playerId, 'pause');
                }
            }
        });
    },


    // create and add player to the vimeo list players
    addPlayer: function (jqPlayerWrapper: JQuery) {
        var playerId = tdVimeoPlayers.tdPlayerContainer + '_' + tdVimeoPlayers.players.length,
            vimeoPlayer = tdVimeoPlayers.createPlayer(playerId, jqPlayerWrapper);

        jqPlayerWrapper.parent().find('.td_vimeo_control').data('player-id', playerId);

        var vimeoVideoElements = jqPlayerWrapper.parent().find('.td_click_video_vimeo');
        for (var j = 0; j < vimeoVideoElements.length; j++) {
            jQuery(vimeoVideoElements[j]).data('player-id', playerId);

            if (j + 1 < vimeoVideoElements.length) {
                jQuery(vimeoVideoElements[j]).data('next-video-id', jQuery(vimeoVideoElements[j + 1]).data('video-id'));
            } else {
                jQuery(vimeoVideoElements[j]).data('next-video-id', jQuery(vimeoVideoElements[0]).data('video-id'));
            }
        }

        if ('1' == jqPlayerWrapper.data('autoplay')) {
            vimeoPlayer.autoplay = 1;
        }

        var firstVideo = jqPlayerWrapper.data('first-video');

        if (undefined !== firstVideo && '' !== firstVideo) {
            vimeoPlayer.createPlayer(firstVideo);
        }

        tdVimeoPlayers.players.push(vimeoPlayer);

        return vimeoPlayer;
    },


    // play or pause a video or the current (first) video
    operatePlayer: function (playerId: string, option: string, videoId?: string) {
        for (var i = 0; i < tdVimeoPlayers.players.length; i++) {

            if (tdVimeoPlayers.players[i].playerId == playerId) {

                var vimeoPlayer = tdVimeoPlayers.players[i];

                if ('play' === option) {

                    vimeoPlayer.autoplay = 1;

                    if (undefined !== videoId) {

                        // the existing autoplay is reset to allow autoplay when we have videoId (a video from the playlist was clicked)
                        tdVimeoPlayers.existingAutoplay = false;

                        vimeoPlayer.createPlayer(videoId);
                    } else {
                        vimeoPlayer.playerPlay();
                    }

                } else if ('pause' === option) {
                    vimeoPlayer.playerPause();
                }

                break;
            }
        }
    },


    // create and return the vimeo player object
    createPlayer: function (playerId: string, jqPlayerWrapper: JQuery) {

        var vimeoPlayer = {

            playerId: playerId,

            // the jq td playlist wrapper ( the player and the playlist)
            jqTDWrapperVideoPlaylist: jqPlayerWrapper.closest('.td_wrapper_video_playlist'),

            // the jq player wrapper
            jqPlayerWrapper: jqPlayerWrapper,

            currentVideoPlaying: '', // not used for the moment

            // @vimeo/player Player instance — used for play/pause control
            player: null as Player | null,

            // main control button of the player
            jqControlPlayer: '' as any,

            autoplay: 0, //autoplay

            createPlayer: function (videoId: string) {
                if ('' !== videoId) {

                    this.currentVideoPlaying = videoId;

                    var current_video_name = window.td_vimeo_list_ids['td_' + videoId]['title'],
                        current_video_time = window.td_vimeo_list_ids['td_' + videoId]['time'];

                    //remove focus from all videos from playlist
                    vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_click_video_vimeo').removeClass('td_video_currently_playing');

                    //add focus class on current playing video
                    vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_' + videoId).addClass('td_video_currently_playing');

                    //adding the current video playing title and time to the control area
                    vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_current_video_play_title_vimeo').html(current_video_name);
                    vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_current_video_play_time_vimeo').html(current_video_time);

                    vimeoPlayer.jqControlPlayer = vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_vimeo_control');

                    // Determine autoplay setting
                    var shouldAutoplay = !tdVimeoPlayers.existingAutoplay && 0 !== vimeoPlayer.autoplay;

                    if (shouldAutoplay) {
                        if (tdDetect.isMobileDevice) {
                            vimeoPlayer.playStatus();
                        } else {
                            vimeoPlayer.pauseStatus();
                        }
                    } else {
                        vimeoPlayer.playStatus();
                    }

                    // Destroy previous player instance if it exists
                    if (vimeoPlayer.player) {
                        vimeoPlayer.player.destroy().catch(function () {});
                    }

                    // Clear the container and create a new @vimeo/player instance
                    // The Player constructor creates an iframe inside the wrapper element
                    vimeoPlayer.jqPlayerWrapper.empty();
                    var playerInstance = new Player(vimeoPlayer.jqPlayerWrapper[0], {
                        id: parseInt(videoId, 10),
                        autoplay: shouldAutoplay,
                    });

                    // Set a DOM id on the iframe for consistency with the original markup
                    var playerEl = (playerInstance as any).element as HTMLIFrameElement | undefined;
                    if (playerEl) {
                        playerEl.id = vimeoPlayer.playerId;
                    }

                    // Store the Player instance
                    vimeoPlayer.player = playerInstance;

                    // Set up event listeners (replaces the old Froogaloop addEvent pattern)
                    playerInstance.on('play', function () {
                        vimeoPlayer.pauseStatus();
                        vimeoPlayer.autoplay = 1;
                    });

                    playerInstance.on('pause', function () {
                        vimeoPlayer.playStatus();
                    });

                    playerInstance.on('ended', function () {

                        var nextVideoId = '',
                            tdVideoCurrentlyPlaying = vimeoPlayer.jqTDWrapperVideoPlaylist.find('.td_video_currently_playing');

                        if (tdVideoCurrentlyPlaying.length) {
                            var nextSibling = jQuery(tdVideoCurrentlyPlaying).next('.td_click_video_vimeo');
                            if (nextSibling.length) {
                                nextVideoId = jQuery(nextSibling).data('video-id');
                            }
                        }

                        if ('' !== nextVideoId) {
                            vimeoPlayer.createPlayer(nextVideoId);

                            if (tdDetect.isMobileDevice) {
                                vimeoPlayer.playStatus();
                            } else {
                                vimeoPlayer.pauseStatus();
                            }
                        } else {
                            vimeoPlayer.playStatus();
                        }
                    });
                }
            },

            // play the current video
            playerPlay: function () {
                vimeoPlayer.autoplay = 1;
                if (vimeoPlayer.player) {
                    vimeoPlayer.player.play().catch(function () {});
                }
            },

            // pause the current video
            playerPause: function () {
                if (vimeoPlayer.player) {
                    vimeoPlayer.player.pause().catch(function () {});
                }
            },

            // change status to 'play' (show play button)
            playStatus: function () {
                vimeoPlayer.jqControlPlayer.removeClass('td-sp-video-pause').addClass('td-sp-video-play');
            },

            // change status to 'pause' (show pause button)
            pauseStatus: function () {
                vimeoPlayer.jqControlPlayer.removeClass('td-sp-video-play').addClass('td-sp-video-pause');
            }
        };

        return vimeoPlayer;
    }
};
